<template>
  <!-- CTA CONTACTO -->
  <section :class="[bgClass, 'py-6 md:py-16 px-6']">
    <div class="max-w-5xl mx-auto bg-white rounded-2xl shadow-2xl py-12 px-6 text-center">
      <h2 class="text-xl sm:text-2xl md:text-3xl font-bold text-[#101541] mb-8 md:whitespace-pre-line">
        {{ $t('footer.ctaTitle') }}
      </h2>
      <div class="flex justify-center gap-6">
        <a
          :href="whatsappLink"
          target="_blank"
          rel="noopener noreferrer"
          class="bg-[#2F3A8F] hover:bg-[#232C73] text-white font-semibold px-8 py-3 rounded-lg shadow-md transition"
        >
          {{ $t('footer.btnWhatsapp') }}
        </a>

        <a
          @click="openModal"
          class="bg-[#2F3A8F] hover:bg-[#232C73] text-white font-semibold px-8 py-3 rounded-lg shadow-md transition cursor-pointer"
        >
          {{ $t('footer.btnMail') }}
        </a>
      </div>
    </div>
  </section>

  <footer class="bg-[#101541] text-white pb-6 md:py-10 px-6 md:px-20 font-montserrat relative">
    <!-- Logo -->
    <div class="absolute left-1/2 -translate-x-1/2 -top-6 md:-top-16 z-30">
      <img src="@/assets/Logo-INBROS.png" alt="INBROS" class="h-38 md:h-64" />
    </div>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-8 pt-20 sm:pt-40 md:pt-32">
      <!-- Dirección -->
      <div class="text-center flex flex-col items-center">
        <h3 class="font-semibold mb-2">{{ $t('footer.findUs') }}</h3>
        <p class="text-sm leading-tight">
          {{ $t('footer.address') }}<br />
          {{ $t('footer.addressContinue1') }} <br />
          {{ $t('footer.addressContinue2') }}
        </p>
        <div class="mt-4 space-y-2 flex flex-col items-center">
          <RouterLink to="/about#ubicaciones" class="text-white text-sm hover:underline block">
            {{ $t('footer.allLocations') }}
          </RouterLink>
          <RouterLink to="/faq" class="text-white text-sm hover:underline block">
            {{ $t('footer.faq') }}
          </RouterLink>
        </div>
      </div>
      <!-- Teléfono -->

      <div class="text-center">
        <h3 class="font-semibold mb-2">{{ $t('footer.contactUs') }}</h3>
        <p class="text-sm">{{ $t('footer.phone') }}</p>
        <div class="mt-4 space-y-2">
          <RouterLink to="/about#ubicaciones" class="text-white text-sm hover:underline block">
            {{ $t('footer.moreBranches') }}
          </RouterLink>
          <RouterLink to="/aviso" class="text-white text-sm hover:underline block">
            {{ $t('footer.privacy') }}
          </RouterLink>
        </div>
      </div>

      <!-- Redes y apps -->
      <div class="text-center flex flex-col items-center">
        <h3 class="font-semibold mb-2">{{ $t('footer.followUs') }}</h3>
        <div class="flex space-x-4 mb-3">
          <a
            href="https://www.facebook.com/inbrosseguroscdobregon/?locale=es_LA"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <i class="ri-facebook-fill text-2xl"></i>
          </a>
          <a
            href="https://www.instagram.com/inbrosmx/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <i class="ri-instagram-line text-2xl"></i>
          </a>
          <a
            href="https://www.linkedin.com/company/inbros/?originalSubdomain=mx"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <i class="ri-linkedin-box-fill text-2xl"></i>
          </a>
        </div>

        <p class="font-semibold text-sm mb-2">{{ $t('footer.downloadApp') }}</p>
        <div class="flex space-x-2">
          <a
            href="https://play.google.com/store/apps/details?id=com.segurosinbros.inbros&hl=es_MX&pli=1"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Google Play"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
              alt="Google Play"
              class="h-8"
            />
          </a>
          <a
            href="https://apps.apple.com/mx/app/inbros-seguros/id1519545891"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="App Store"
          >
            <img
              src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
              alt="App Store"
              class="h-8"
            />
          </a>
        </div>
      </div>
    </div>
    <!-- Copyright -->
    <div class="mt-10 border-t pt-4 text-center text-xs text-white/70 flex flex-col items-center">
      <span> {{ t('footer.copyright', { year: new Date().getFullYear() }) }}</span>
    </div>
  </footer>

  <!-- Modal Correo -->
  <!-- Overlay -->
  <div
    v-if="showModal"
    @click="closeModal"
    class="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 px-4"
  >
    <!-- Modal -->
    <div @click.stop class="bg-white w-full max-w-lg rounded-2xl shadow-2xl p-8 relative animate-fadeIn">
      <!-- Cerrar -->
      <button @click="closeModal" class="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-xl">✕</button>

      <!-- Título -->
      <h3 class="text-2xl font-bold text-[#101541] mb-6 text-center">
        {{ $t('email.label') }}
      </h3>

      <!-- Formulario -->
      <!-- Overlay -->
      <form class="space-y-5" @submit="handleSubmit" novalidate>
        <!-- Nombre -->
        <div>
          <label class="block text-sm font-medium text-[#101541] mb-1">
            {{ $t('email.name') }}
          </label>
          <input
            v-model="form.name"
            type="text"
            :class="[
              'w-full border rounded-lg px-4 py-2 focus:ring-2 focus:outline-none transition',
              errors.name ? 'border-red-500 focus:ring-red-400' : 'border-gray-300 focus:ring-[#2F3A8F]'
            ]"
          />
          <p v-if="errors.name" class="text-red-500 text-sm mt-1">
            {{ errors.name }}
          </p>
        </div>

        <!-- Email -->
        <div>
          <label class="block text-sm font-medium text-[#101541] mb-1">
            {{ $t('email.mail') }}
          </label>
          <input
            v-model="form.email"
            type="email"
            :class="[
              'w-full border rounded-lg px-4 py-2 focus:ring-2 focus:outline-none transition',
              errors.email ? 'border-red-500 focus:ring-red-400' : 'border-gray-300 focus:ring-[#2F3A8F]'
            ]"
          />
          <p v-if="errors.email" class="text-red-500 text-sm mt-1">
            {{ errors.email }}
          </p>
        </div>

        <!-- Confirmar Email -->
        <div>
          <label class="block text-sm font-medium text-[#101541] mb-1">
            {{ $t('email.validation.confirmMail') }}
          </label>
          <input
            v-model="form.confirmEmail"
            type="email"
            :class="[
              'w-full border rounded-lg px-4 py-2 focus:ring-2 focus:outline-none transition',
              errors.confirmEmail
                ? 'border-red-500 focus:ring-red-400'
                : form.confirmEmail && form.confirmEmail === form.email
                ? 'border-green-500 focus:ring-green-400'
                : 'border-gray-300 focus:ring-[#2F3A8F]'
            ]"
          />
          <p v-if="errors.confirmEmail" class="text-red-500 text-sm mt-1">
            {{ errors.confirmEmail }}
          </p>

          <p v-else-if="form.confirmEmail && form.confirmEmail === form.email" class="text-green-600 text-sm mt-1">
            {{ $t('email.validation.emailsMatch') }}
          </p>
        </div>

        <!-- Mensaje -->
        <div>
          <label class="block text-sm font-medium text-[#101541] mb-1">
            {{ $t('email.message') }}
          </label>
          <textarea
            v-model="form.message"
            rows="4"
            :class="[
              'w-full border rounded-lg px-4 py-2 focus:ring-2 focus:outline-none resize-none transition',
              errors.message ? 'border-red-500 focus:ring-red-400' : 'border-gray-300 focus:ring-[#2F3A8F]'
            ]"
          ></textarea>
          <p v-if="errors.message" class="text-red-500 text-sm mt-1">
            {{ errors.message }}
          </p>
        </div>

        <!-- Success / Error Messages -->
        <div v-if="status === 'success'" class="bg-green-100 text-green-700 p-3 rounded-lg text-sm">
          {{ $t('email.correctSent') }}
        </div>

        <div v-if="status === 'error'" class="bg-red-100 text-red-700 p-3 rounded-lg text-sm">
          {{ $t('email.errorSent') }}
        </div>

        <!-- Botones -->
        <div class="flex justify-end gap-4 pt-4">
          <button
            type="button"
            @click="closeModal"
            class="px-5 py-2 rounded-lg text-[#101541] border border-gray-300 hover:bg-gray-100 transition"
            :disabled="loading"
          >
            {{ $t('email.cancel') }}
          </button>

          <button
            type="submit"
            :disabled="loading"
            class="px-6 py-2 bg-[#2F3A8F] hover:bg-[#232C73] text-white rounded-lg shadow-md transition flex items-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
          >
            <svg
              v-if="loading"
              class="animate-spin h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
            </svg>

            {{ loading ? t('email.sending') : t('email.send') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { ref, watch, onMounted, onUnmounted, reactive } from 'vue'
import { useToast } from 'vue-toastification'
import { enviarMensajeFooter } from '@/services/email'

defineProps({
  bgClass: {
    type: String,
    default: 'bg-gradient-to-b from-transparent from-50% to-[#101541] to-50%'
  }
})

const { t } = useI18n()
const toast = useToast()

const primaryPhone = '6441500822'
const defaultMessage = 'Hola, me gustaría cotizar un seguro.'

const whatsappLink = `https://wa.me/${primaryPhone}?text=${encodeURIComponent(defaultMessage)} `

const showModal = ref(false)
const loading = ref(false)
const status = ref(null) // null | 'success' | 'error'

const form = reactive({
  name: '',
  email: '',
  confirmEmail: '',
  message: ''
})

const errors = reactive({
  name: '',
  email: '',
  confirmEmail: '',
  message: ''
})

/* ---------------- OPEN / CLOSE ---------------- */

const openModal = () => {
  showModal.value = true
}

function closeModal() {
  resetForm()
  showModal.value = false
}

/* ---------------- BODY SCROLL LOCK ---------------- */

watch(showModal, (val) => {
  if (val) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = ''
  }
})

/* ---------------- ESC CLOSE ---------------- */

const handleEsc = (e) => {
  if (e.key === 'Escape' && showModal.value) {
    closeModal()
  }
}

onMounted(() => {
  window.addEventListener('keydown', handleEsc)
})

onUnmounted(() => {
  window.removeEventListener('keydown', handleEsc)
})

/* ---------------- VALIDATION ---------------- */

const validateEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

function validateForm() {
  errors.name = ''
  errors.email = ''
  errors.confirmEmail = ''
  errors.message = ''

  let isValid = true

  if (!form.name.trim()) {
    errors.name = t('email.validation.nameRequired')
    isValid = false
  }

  if (!form.email.trim()) {
    errors.email = t('email.validation.emailRequired')
    isValid = false
  } else if (!validateEmail(form.email)) {
    errors.email = t('email.validation.invalidEmail')
    isValid = false
  }

  if (!form.confirmEmail.trim()) {
    errors.confirmEmail = t('email.validation.confirmEmailRequired')
    isValid = false
  } else if (form.email !== form.confirmEmail) {
    errors.confirmEmail = t('email.validation.emailsDontMatch')
    isValid = false
  }

  if (!form.message.trim()) {
    errors.message = t('email.validation.messageRequired')
    isValid = false
  }

  return isValid
}

/* ---------------- SUBMIT ---------------- */
function resetForm() {
  form.name = ''
  form.email = ''
  form.confirmEmail = ''
  form.message = ''

  errors.name = ''
  errors.email = ''
  errors.confirmEmail = ''
  errors.message = ''
}

async function handleSubmit(e) {
  e.preventDefault()

  if (!validateForm()) return

  loading.value = true
  status.value = null

  try {
    // Enviar datos al backend
    const resultado = await enviarMensajeFooter({
      nombre: form.name.trim(),
      email: form.email.trim(),
      mensaje: form.message.trim()
    })

    if (resultado.success) {
      // Éxito - mostrar mensaje y cerrar modal
      toast.success(t('email.correctSent'))
      closeModal()
    } else {
      // Error del backend
      status.value = 'error'
      toast.error(resultado.message || t('email.errorSent'))
    }
  } catch (error) {
    console.error('Error al enviar mensaje:', error)
    status.value = 'error'
    toast.error(t('email.errorSent'))
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
@import 'https://cdn.jsdelivr.net/npm/remixicon@3.4.0/fonts/remixicon.css';
</style>
